import { FC } from "react";

import Text from "../../../../components/Text";
import { Question } from "../../../../types/Question";
import { formatAnswer } from "../../../../utils/question";

import styles from "./styles.module.scss";

type Props = {
    user: { questions: Question[] };
};

const Answers: FC<Props> = ({ user }) => {
    return (
        <div className={styles.answers}>
            {user.questions.map((question) => (
                <div key={question.id} className={styles.answer}>
                    <Text variant="body-bold" className={styles.questionLabel}>
                        {question.label}
                    </Text>
                    <Text className={styles.answerText} variant="body">
                        {formatAnswer(question)}
                    </Text>
                </div>
            ))}
        </div>
    );
};

export default Answers;
